module.exports = __webpack_public_path__ + "static/9057c57dbb4e6c92d41eda0c59af94ea1fec4d5d7429e849c082b388955117c2-49b31abebde387f8612754f9bb0eed1c.jpeg";